import { normalizeAnalysisError } from "./analysis-error";

const SAFE_ANALYSIS_ERRORS = [
  "The analysis engine could not start.",
  "Analysis stopped before it finished.",
  "Analysis finished but could not be saved.",
];

export const analysisProgressErrorCopy = (error: string | null) =>
  error && SAFE_ANALYSIS_ERRORS.some((prefix) => error.startsWith(prefix))
    ? error
    : normalizeAnalysisError(error, "analysis").userMessage;
